export const StatesMap = {
    'BR': {
        'AC': 'Acre',
        'AL': 'Alagoas',
        'AP': 'Amapá',
        'AM': 'Amazonas',
        'BA': 'Bahia',
        'CE': 'Ceará',
        'DF': 'Distrito Federal',
        'ES': 'Espirito Santo',
        'GO': 'Goiás',
        'MA': 'Maranhão',
        'MS': 'Mato Grosso do Sul',
        'MT': 'Mato Grosso',
        'MG': 'Minas Gerais',
        'PA': 'Pará',
        'PB': 'Paraíba',
        'PR': 'Paraná',
        'PE': 'Pernambuco',
        'PI': 'Piauí',
        'RJ': 'Rio de Janeiro',
        'RN': 'Rio Grande do Norte',
        'RS': 'Rio Grande do Sul',
        'RO': 'Rondônia',
        'RR': 'Roraima',
        'SC': 'Santa Catarina',
        'SP': 'São Paulo',
        'SE': 'Sergipe',
        'TO': 'Tocantins',
    },
    'CA': {
        'ON': 'Ontario' ,
        'QC': 'Quebec' ,
        'AB': 'Alberta' ,
        'NL': 'Terra Nova e Labrador' ,
        'BC': 'British Columbia' ,
        'NS': 'Nova Escócia' ,
        'PE': 'Prince Edward Island' ,
        'MB': 'Manitoba' ,
        'SK': 'Saskatchewan' ,
        'NB': 'New Brunswick' ,
    },
    'US': {
        'AL': 'Alabama',
        'AK': 'Alasca',
        'AR': 'Arcansas',
        'AZ': 'Arizona',
        'CA': 'Califórnia',
        'NC': 'Carolina do Norte',
        'SC': 'Carolina do Sul',
        'CO': 'Colorado',
        'CT': 'Connecticut',
        'ND': 'Dakota do Norte',
        'SD': 'Dakota do Sul',
        'DE': 'Delaware',
        'FL': 'Flórida',
        'GA': 'Geórgia',
        'HI': 'Havaí',
        'ID': 'Idaho',
        'IL': 'Illinois',
        'IN': 'Indiana',
        'IA': 'Iowa',
        'KS': 'Kansas',
        'KY': 'Kentucky',
        'LA': 'Louisiana',
        'ME': 'Maine',
        'MD': 'Maryland',
        'MA': 'Massachusetts',
        'MI': 'Michigan',
        'MN': 'Minesota',
        'MS': 'Mississippi',
        'MO': 'Missouri',
        'MT': 'Montana',
        'NE': 'Nebraska',
        'NV': 'Nevada',
        'NH': 'New Hampshire',
        'NJ': 'New Jersey',
        'NY': 'Nova Iorque',
        'NM': 'Novo México',
        'OK': 'Oklahoma',
        'OH': 'Ohio',
        'OR': 'Oregon',
        'PA': 'Pennsylvania',
        'RI': 'Rhode Island',
        'TN': 'Tennessee',
        'TX': 'Texas',
        'UT': 'Utah',
        'VT': 'Vermont',
        'VA': 'Virginia',
        'WV': 'Virgínia Ocidental',
        'WA': 'Washington',
        'WI': 'Wisconsin',
        'WY': 'Wyoming',
    },
};
